import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Componenttextimage from '../components/componenttextimage'
import Component3images from '../components/component3images'
import Componentparameters from '../components/componentparameters'
import Componentfaq from '../components/componentfaq'
import FooterMain from '../components/footer-main'
import './goldenrod.css'

const Goldenrod = (props) => {
  return (
    <div className="goldenrod-container">
      <Helmet>
        <title>Arcobo GoldenRod | Компактный промышленный WAAM-принтер</title>
        <meta
          name="description"
          content="Компактный промышленный WAAM-принтер для изготовления и восстановления металлических деталей. Готовая система для быстрого внедрения на производстве."
        />
        <meta
          property="og:title"
          content="Arcobo GoldenRod | Компактный промышленный WAAM-принтер"
        />
        <meta
          property="og:description"
          content="Компактный промышленный WAAM-принтер для изготовления и восстановления металлических деталей. Готовая система для быстрого внедрения на производстве."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Arcobo GoldenRod | Компактный промышленный WAAM-принтер"
        />
        <meta
          name="twitter:description"
          content="Компактный промышленный WAAM-принтер для изготовления и восстановления металлических деталей. Готовая система для быстрого внедрения на производстве."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/goldenrod"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/goldenrod"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Goldenrod","item":"https://arcobo.tech/goldenrod"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name8"></HeaderMain>
      <hr className="goldenrod-separator1"></hr>
      <Componenttextimage
        image1Src="/2_3D Printing/2_3_3D Printers/goldenrod%201-1500w.webp"
        image1Alt="3D-принтер Arcobo Goldenrod"
        rootClassName="componenttextimageroot-class-name12"
        textComponent={
          <Fragment>
            <span className="goldenrod-text100">
              <span className="goldenrod-text101 H1_extrasmall">
                Компактная WAAM-система для промышленного изготовления и
                восстановления металлических деталей
              </span>
              <br className="H1_extrasmall"></br>
              <span>
                Goldenrod объединяет роботизированную систему печати, закрытую
                рабочую камеру и автоматизированное управление в едином
                промышленном комплексе. Оптимальное решение для предприятий,
                которым необходима безопасная, компактная и
                высокопроизводительная система WAAM-печати.
              </span>
              <br></br>
              <br className="goldenrod-text105"></br>
              <span className="goldenrod-text106 H1_small">
                Преимущества и выгоды:
              </span>
              <br></br>
              <span className="goldenrod-text108">✔ </span>
              <span className="goldenrod-text109 H1_extrasmall">
                Компактное размещение в цехе
              </span>
              <br></br>
              <span>
                Одна система подходит как для изготовления новых деталей, так и
                для восстановления дорогостоящих узлов методом роботизированной
                наплавки
              </span>
              <br></br>
              <span className="goldenrod-text113">✔ </span>
              <span className="goldenrod-text114 H1_extrasmall">
                Высокая производительность
              </span>
              <br></br>
              <span>
                Автоматизированная WAAM-система обеспечивает быстрое
                изготовление новых деталей и восстановление дорогостоящих узлов.
              </span>
              <br></br>
              <span className="goldenrod-text118">✔ </span>
              <span className="goldenrod-text119 H1_extrasmall">
                Повышенная безопасность
              </span>
              <br className="H1_extrasmall"></br>
              <span>
                Закрытая рабочая зона защищает персонал от сварочного излучения,
                искр и аэрозолей, создавая безопасные условия эксплуатации.
              </span>
              <br></br>
              <span className="goldenrod-text123">✔ </span>
              <span className="goldenrod-text124 H1_extrasmall">
                Готовность к промышленной эксплуатации
              </span>
              <br></br>
              <span>
                Комплекс предназначен для ежедневной работы в условиях серийного
                производства и легко интегрируется в существующие
                технологические процессы.
              </span>
            </span>
          </Fragment>
        }
        componentTitle="Arcobo Goldenrod"
      ></Componenttextimage>
      <Component3images
        image1Src="/2_3D Printing/2_3_3D Printers/2_3_2_Golderrod/goldenrod%2011-200w.webp"
        image1Alt="3D-принтер Arcobo Goldenrod"
        image2Src="/2_3D Printing/3d_02-200h.webp"
        image2Alt="WAAM 3D-печать металлом"
        image3Src="/2_3D Printing/3d_03-200h.webp"
        image3Alt="WAAM 3D-печать металлом"
        rootClassName="component3imagesroot-class-name21"
      ></Component3images>
      <Componentparameters
        text1={
          <Fragment>
            <span className="goldenrod-text127">
              <span className="goldenrod-text128">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Промышленный робот-манипулятор</span>
              <br></br>
              <span className="goldenrod-text131">•</span>
              <span className="goldenrod-text132">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Двухсевой позиционер</span>
              <br></br>
              <span className="goldenrod-text135">•</span>
              <span className="goldenrod-text136">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Сменный стол для габаритных деталей</span>
              <br></br>
              <span className="goldenrod-text139">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Цифровой сварочный источник</span>
              <br></br>
              <span className="goldenrod-text142">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Система подачи сварочной проволоки</span>
              <br></br>
              <span className="goldenrod-text145">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Закрытая рабочая камера</span>
              <br></br>
              <span className="goldenrod-text148">•</span>
              <span className="goldenrod-text149">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Система вентиляции и фильтрации</span>
              <br></br>
              <span className="goldenrod-text152">•</span>
              <span className="goldenrod-text153">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Система 3D-сканирования</span>
              <br></br>
              <span className="goldenrod-text156">•</span>
              <span className="goldenrod-text157">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Система контроля температуры детали</span>
              <br></br>
              <span className="goldenrod-text160">•</span>
              <span className="goldenrod-text161">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Контроллер управления роботизированным комплексом</span>
              <br></br>
              <span className="goldenrod-text164">•</span>
              <span className="goldenrod-text165">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Программное обеспечение Arcobo WAAM</span>
              <br></br>
              <span className="goldenrod-text168">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Защитная система с блокировкой доступа</span>
            </span>
          </Fragment>
        }
        text2={
          <Fragment>
            <span className="goldenrod-text170">
              <span>
                Тип процесса:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="goldenrod-text172">MIG/MAG/TIG/PAW/LW</span>
              <br className="goldenrod-text173"></br>
              <span>
                Онлайн-мониторинг печати:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="goldenrod-text175">Да</span>
              <br></br>
              <span>
                Производительность печати:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="goldenrod-text178">до 5 кг/час (сталь)</span>
              <br></br>
              <span>
                Максимальная масса детали:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="goldenrod-text181">1500 кг</span>
              <br></br>
              <span>
                Рабочая зона:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="goldenrod-text184">2400 × 2400 × 1500 мм</span>
              <br></br>
              <span>
                Точность позиционирования:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="goldenrod-text187">±0,06 мм</span>
              <br></br>
              <span>
                Диаметры проволоки:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="goldenrod-text190">1,0-2,4 мм</span>
              <br></br>
              <span>Напряжение питания: 3</span>
              <span className="goldenrod-text193">80 В, 50 Гц</span>
              <br></br>
              <span>
                Потребляемая мощность:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="goldenrod-text196">20–25 кВт</span>
            </span>
          </Fragment>
        }
        text3={
          <Fragment>
            <span className="goldenrod-text197">
              <span className="goldenrod-text198">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Технология печати целевых деталей</span>
              <br></br>
              <span className="goldenrod-text201">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Пусконаладочные работы</span>
              <br></br>
              <span className="goldenrod-text204">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Обучение персонала. Базовый курс 4 дня</span>
            </span>
          </Fragment>
        }
        text4={
          <Fragment>
            <span className="goldenrod-text206">
              <span className="goldenrod-text207">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Удаленная диагностика Arcobo</span>
              <br></br>
              <span className="goldenrod-text210">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Интеграция с MES/ERP</span>
            </span>
          </Fragment>
        }
        text5={
          <Fragment>
            <span className="goldenrod-text212">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur
            </span>
          </Fragment>
        }
        heading1="A. Базовая комплектация"
        heading2="B. Базовые характеристики"
        heading3="C. В состав поставки включены:"
        heading4="D. Дополнительные опции"
        showDiv5={false}
        mainHeading="Характеристики Arcobo Goldenrod"
        rootClassName="componentparametersroot-class-name5"
      ></Componentparameters>
      <Component3images
        image1Src="/2_3D Printing/3d_11-200h.webp"
        image1Alt="Изделие WAAM 3D-печати"
        image2Src="/2_3D Printing/3d_12-200h.webp"
        image2Alt="Изделие WAAM 3D-печати"
        image3Src="/2_3D Printing/3d_13-200h.webp"
        image3Alt="Изделие WAAM 3D-печати"
        rootClassName="component3imagesroot-class-name22"
      ></Component3images>
      <Componentfaq
        answer1={
          <Fragment>
            <span className="goldenrod-text213">
              <span>
                Goldenrod поставляется с готовыми технологическими режимами
                печати и библиотекой программ для наиболее востребованных
                промышленных деталей. Это позволяет значительно сократить сроки
                внедрения и быстрее приступить к серийному производству.
              </span>
              <br></br>
              <span>
                При использовании двухосевого позиционера система позволяет
                изготавливать детали массой до 250 кг и диаметром до 1350 мм.
                При печати непосредственно на рабочем столе максимальная масса
                изделия может достигать 2500 кг.
              </span>
            </span>
          </Fragment>
        }
        answer2={
          <Fragment>
            <span className="goldenrod-text217">
              Технология наиболее эффективна при изготовлении единичных и
              мелкосерийных деталей, крупных изделий, дорогостоящих сплавов и
              деталей с длительными сроками поставки. WAAM позволяет отказаться
              от дорогостоящей литейной оснастки и значительно сократить сроки
              производства.
            </span>
          </Fragment>
        }
        answer3={
          <Fragment>
            <span className="goldenrod-text218">
              Поддерживается печать более чем из 100 металлических сплавов,
              включая конструкционные и нержавеющие стали, инструментальные
              стали, алюминиевые, бронзовые, никелевые и титановые сплавы.
              Конкретный перечень материалов определяется конфигурацией
              комплекса.
            </span>
          </Fragment>
        }
        answer4={
          <Fragment>
            <span className="goldenrod-text219">
              Стоимость зависит от материала, массы детали, сложности геометрии,
              объема последующей мехобработки и размера партии. Для большинства
              единичных изделий расчет выполняется индивидуально на основе
              CAD-модели.
            </span>
          </Fragment>
        }
        answer5={
          <Fragment>
            <span className="goldenrod-text220">
              Для предприятий с регулярной потребностью в изготовлении или
              восстановлении металлических деталей инвестиции в WAAM обычно
              окупаются за счет сокращения сроков производства, снижения
              закупочных затрат и отказа от дорогостоящей оснастки. Конкретный
              срок окупаемости определяется производственной программой
              предприятия.
            </span>
          </Fragment>
        }
        answer6={
          <Fragment>
            <span className="goldenrod-text221">answer</span>
          </Fragment>
        }
        answer7={
          <Fragment>
            <span className="goldenrod-text222">answer</span>
          </Fragment>
        }
        answer8={
          <Fragment>
            <span className="goldenrod-text223">answer</span>
          </Fragment>
        }
        showDiv5
        showDiv6
        showDiv7
        question1="Какие детали можно изготавливать на Arcobo Goldenrod?"
        question2="Когда WAAM выгоднее традиционного производства?"
        question3="Из каких материалов можно печатать?"
        question4="Сколько стоит изготовление детали методом WAAM?"
        question5="Какой срок окупаемости WAAM?"
        rootClassName="componentfaqroot-class-name11"
      ></Componentfaq>
      <hr className="goldenrod-separator2"></hr>
      <FooterMain rootClassName="footer-mainroot-class-name8"></FooterMain>
    </div>
  )
}

export default Goldenrod
